import React, { FunctionComponent, useState } from 'react';
import {route} from 'b302-frontend-library';
import { useNavigate } from 'react-router-dom';

import HanCheckbox from "../../../utils/HanCheckbox";
import Region from "../../../../networking/models/Region";
import HanButton from "../../../utils/HanButton";
import { ReactComponent as RegionHeader } from '../../../../assets/images/headers/illustratie_region.svg';

interface Props {
    regions: Region[];
}

const SelectRegionsContent: FunctionComponent<Props> = (props) => {
    const navigate = useNavigate();

    const [selectedRegions, setSelectedRegions] = useState<number[]>([]);

    const toggleRegion = (region: number) => {
        const newSelectedRegions = [...selectedRegions];
        const index = newSelectedRegions.findIndex(r => r === region);

        if(index === -1) {
            newSelectedRegions.push(region);
        } else {
            newSelectedRegions.splice(index, 1);
        }

        setSelectedRegions(newSelectedRegions);
    };

    const openUniversities = () => {
        navigate(
            route('universities') + `?continents=${selectedRegions.join(',')}`
        );
    };

    return (
        <>
            <div className={'select-regions__image-container'}>
                <RegionHeader className={'select-regions__image'} />
            </div>

            <div className={'main__wrapper'}>
                <h1 className={'select-regions__title'}>Select your region(s)</h1>

                <div className={'select-regions__regions'}>
                    { props.regions.map(region => (
                        <div className={'select-regions__form-group'} key={region.id}>
                            <HanCheckbox onClick={() => toggleRegion(region.id!)} checked={selectedRegions.includes(region.id!)} />
                            <label>{ region.name }</label>
                        </div>
                    )) }
                </div>

                <HanButton onClick={openUniversities} disabled={!selectedRegions.length}>
                    Next step
                </HanButton>
            </div>
        </>
    );
};

export default SelectRegionsContent;
